// X-57 Maxwell high-lift BET (Blade Element Theory) actuator disks.
//
// The 12 leading-edge high-lift propeller disks, extracted from the real
// Flow360 case JSON (`BETDisks[]`, x57-htp-wake case-e0d22bed). The solver
// case is in FEET; these are converted to INCHES (×12) to match the
// x57_maxwell render OBJ's frame (VSP: X streamwise, Y spanwise, Z up), so
// they overlay the aircraft mesh with no further transform.
//
// The 2 wingtip CRUISE propellers are NOT defined in any X-57 BET source we
// have — only these 12 high-lift disks exist. `axis` is the thrust direction
// (−X, i.e. forward); the disk plane is therefore the Y–Z plane.

export interface BetDiskSpec {
  id: string;
  /** Hub center in the render OBJ frame (VSP inches). */
  center: [number, number, number];
  /** Unit thrust axis; the disk plane is perpendicular to this. */
  axis: [number, number, number];
  /** Disk radius in inches. */
  radius: number;
}

export const X57_BET_DISKS: BetDiskSpec[] = [
  { id: "hl1", center: [140.038, -148.38, 82.238], axis: [-1, 0, 0], radius: 11.398 },
  { id: "hl2", center: [136.108, -125.7, 82.238], axis: [-1, 0, 0], radius: 11.398 },
  { id: "hl3", center: [138.091, -103.02, 82.238], axis: [-1, 0, 0], radius: 11.398 },
  { id: "hl4", center: [134.614, -80.34, 82.238], axis: [-1, 0, 0], radius: 11.398 },
  { id: "hl5", center: [136.597, -57.66, 82.238], axis: [-1, 0, 0], radius: 11.398 },
  { id: "hl6", center: [134.614, -34.98, 82.238], axis: [-1, 0, 0], radius: 11.398 },
  { id: "hl7", center: [134.614, 34.98, 82.238], axis: [-1, 0, 0], radius: 11.398 },
  { id: "hl8", center: [136.597, 57.66, 82.238], axis: [-1, 0, 0], radius: 11.398 },
  { id: "hl9", center: [134.614, 80.34, 82.238], axis: [-1, 0, 0], radius: 11.398 },
  { id: "hl10", center: [138.091, 103.02, 82.238], axis: [-1, 0, 0], radius: 11.398 },
  { id: "hl11", center: [136.108, 125.7, 82.238], axis: [-1, 0, 0], radius: 11.398 },
  { id: "hl12", center: [140.038, 148.38, 82.238], axis: [-1, 0, 0], radius: 11.398 },
];
